export enum IconEnum {
  MDI_ACCOUNT = 'mdi-account',
  MDI_ACCOUNT_MULTIPLE = 'mdi-account-multiple',
  MDI_AIRPLANE = 'mdi-airplane',
  MDI_ANCHOR = 'mdi-anchor',
  MDI_ANDROID_STUDIO = 'mdi-android-studio',
  MDI_ANTENNA = 'mdi-antenna',
  MDI_ARCHIVE = 'mdi-archive',
  MDI_ASTERISK = 'mdi-asterisk',
  MDI_ATOM = 'mdi-atom',
  MDI_BANK = 'mdi-bank',
  MDI_BARLEY = 'mdi-barley',
  MDI_BASKET = 'mdi-basket',
  MDI_TENNIS_BALL = 'mdi-tennis-ball',
  MDI_BAT = 'mdi-bat',
  MDI_BEACH = 'mdi-beach',
  MDI_BED = 'mdi-bed',
  MDI_BEER = 'mdi-beer',
  MDI_BICYCLE = 'mdi-bicycle',
  MDI_BINOCULARS = 'mdi-binoculars',
  MDI_BOMB = 'mdi-bomb',
  MDI_BOOK_OPEN_BLANK_VARIANT = 'mdi-book-open-blank-variant',
  MDI_BOOKMARK = 'mdi-bookmark',
  MDI_BRIEFCASE_VARIANT = 'mdi-briefcase-variant',
  MDI_BRUSH = 'mdi-brush',
  MDI_BUG = 'mdi-bug',
  MDI_BULLHORN = 'mdi-bullhorn',
  MDI_BUS = 'mdi-bus',
  MDI_CACTUS = 'mdi-cactus',
  MDI_CALCULATOR = 'mdi-calculator',
  MDI_CALENDAR_MONTH = 'mdi-calendar-month',
  MDI_CAMERA = 'mdi-camera',
  MDI_CAR = 'mdi-car',
  MDI_CARDS = 'mdi-cards',
  MDI_CARDS_CLUB = 'mdi-cards-club',
  MDI_CARDS_HEART = 'mdi-cards-heart',
  MDI_CART = 'mdi-cart',
  MDI_CASH_MULTIPLE = 'mdi-cash-multiple',
  MDI_CASH_REGISTER = 'mdi-cash-register',
  MDI_CASTLE = 'mdi-castle',
  MDI_CELLPHONE_IPHONE = 'mdi-cellphone-iphone',
  MDI_CHART_AREASPLINE_VARIANT = 'mdi-chart-areaspline-variant',
  MDI_CHAT = 'mdi-chat',
  MDI_CHECK_BOLD = 'mdi-check-bold',
  MDI_CHECKBOX_MULTIPLE_BLANK = 'mdi-checkbox-multiple-blank',
  MDI_CHESS_PAWN = 'mdi-chess-pawn',
  MDI_CITY_VARIANT = 'mdi-city-variant',
  MDI_CLIPBOARD_OUTLINE = 'mdi-clipboard-outline',
  MDI_CLOCK = 'mdi-clock',
  MDI_CLOUD = 'mdi-cloud',
  MDI_COFFEE = 'mdi-coffee',
  MDI_COGS = 'mdi-cogs',
  MDI_COMPASS = 'mdi-compass',
  MDI_CONNECTION = 'mdi-connection',
  MDI_CONTROLLER_CLASSIC = 'mdi-controller-classic',
  MDI_COOKIE = 'mdi-cookie',
  MDI_CREATION = 'mdi-creation',
  MDI_CREDIT_CARD = 'mdi-credit-card',
  MDI_CUBE = 'mdi-cube',
  MDI_CURSOR_DEFAULT_CLICK = 'mdi-cursor-default-click',
  MDI_DATABASE = 'mdi-database',
  MDI_DESKTOP_MAC = 'mdi-desktop-mac',
  MDI_DIAMOND_STONE = 'mdi-diamond-stone',
  MDI_DNA = 'mdi-dna',
  MDI_DOG = 'mdi-dog',
  MDI_DUCK = 'mdi-duck',
  MDI_EARTH = 'mdi-earth',
  MDI_EMAIL_MULTIPLE = 'mdi-email-multiple',
  MDI_EMOTICON_HAPPY = 'mdi-emoticon-happy',
  MDI_FERRY = 'mdi-ferry',
  MDI_FILE_MULTIPLE = 'mdi-file-multiple',
  MDI_FILMSTRIP_BOX = 'mdi-filmstrip-box',
  MDI_FIRE = 'mdi-fire',
  MDI_FISH = 'mdi-fish',
  MDI_FLAG_VARIANT = 'mdi-flag-variant',
  MDI_FLASH = 'mdi-flash',
  MDI_BRIGHTNESS_5 = 'mdi-brightness-5',
  MDI_FLOWER = 'mdi-flower',
  MDI_FOOD_APPLE = 'mdi-food-apple',
  MDI_FACTORY = 'mdi-factory',
  MDI_FOUNTAIN_PEN_TIP = 'mdi-fountain-pen-tip',
  MDI_GAVEL = 'mdi-gavel',
  MDI_GHOST = 'mdi-ghost',
  MDI_GIFT = 'mdi-gift',
  MDI_GLASS_COCKTAIL = 'mdi-glass-cocktail',
  MDI_GLASSES = 'mdi-glasses',
  MDI_HAMMER_WRENCH = 'mdi-hammer-wrench',
  MDI_HAND_RIGHT = 'mdi-hand-right',
  MDI_HANDSHAKE = 'mdi-handshake',
  MDI_HEAD = 'mdi-head',
  MDI_HELP = 'mdi-help',
  MDI_HOME = 'mdi-home',
  MDI_IMAGE = 'mdi-image',
  MDI_IMAGE_FILTER_HDR = 'mdi-image-filter-hdr',
  MDI_INBOX = 'mdi-inbox',
  MDI_INFORMATION_VARIANT = 'mdi-information-variant',
  MDI_KEY = 'mdi-key',
  MDI_LAN = 'mdi-lan',
  MDI_LAYERS = 'mdi-layers',
  MDI_LEAD_PENCIL = 'mdi-lead-pencil',
  MDI_LEAF = 'mdi-leaf',
  MDI_LIFEBUOY = 'mdi-lifebuoy',
  MDI_LIGHTBULB_ON = 'mdi-lightbulb-on',
  MDI_LIGHTHOUSE_ON = 'mdi-lighthouse-on',
  MDI_LOCK = 'mdi-lock',
  MDI_MAGNET = 'mdi-magnet',
  MDI_MAGNIFY = 'mdi-magnify',
  MDI_MAILBOX = 'mdi-mailbox',
  MDI_MAP = 'mdi-map',
  MDI_MEDAL = 'mdi-medal',
  MDI_MICROPHONE = 'mdi-microphone',
  MDI_MICROSCOPE = 'mdi-microscope',
  MDI_MINE = 'mdi-mine',
  MDI_MOON_WANING_CRESCENT = 'mdi-moon-waning-crescent',
  MDI_MOON_FULL = 'mdi-moon-full',
  MDI_MOTION = 'mdi-motion',
  MDI_MOVIE_OPEN = 'mdi-movie-open',
  MDI_MUSIC = 'mdi-music',
  MDI_NEAR_ME = 'mdi-near-me',
  MDI_NEWSPAPER_VARIANT = 'mdi-newspaper-variant',
  MDI_NOTE = 'mdi-note',
  MDI_NOTEBOOK = 'mdi-notebook',
  MDI_OCTAGON = 'mdi-octagon',
  MDI_OCTAGRAM = 'mdi-octagram',
  MDI_OFFER = 'mdi-offer',
  MDI_OFFICE_BUILDING = 'mdi-office-building',
  MDI_PACKAGE_VARIANT = 'mdi-package-variant',
  MDI_PARACHUTE = 'mdi-parachute',
  MDI_PEN = 'mdi-pen',
  MDI_PENCIL_RULER = 'mdi-pencil-ruler',
  MDI_PHONE_CLASSIC = 'mdi-phone-classic',
  MDI_PIGGY_BANK = 'mdi-piggy-bank',
  MDI_PIN = 'mdi-pin',
  MDI_PINE_TREE = 'mdi-pine-tree',
  MDI_PLAY = 'mdi-play',
  MDI_PLUS_CIRCLE = 'mdi-plus-circle',
  MDI_POLL = 'mdi-poll',
  MDI_POUND = 'mdi-pound',
  MDI_PROJECTOR_SCREEN = 'mdi-projector-screen',
  MDI_PURSE = 'mdi-purse',
  MDI_PUZZLE = 'mdi-puzzle',
  MDI_RADAR = 'mdi-radar',
  MDI_RECYCLE_VARIANT = 'mdi-recycle-variant',
  MDI_RHOMBUS_SPLIT = 'mdi-rhombus-split',
  MDI_ROAD_VARIANT = 'mdi-road-variant',
  MDI_ROBOT = 'mdi-robot',
  MDI_ROCKET_LAUNCH = 'mdi-rocket-launch',
  MDI_ROUTES = 'mdi-routes',
  MDI_RULER = 'mdi-ruler',
  MDI_RUN = 'mdi-run',
  MDI_SACK = 'mdi-sack',
  MDI_SAIL_BOAT = 'mdi-sail-boat',
  MDI_SCALE_BALANCE = 'mdi-scale-balance',
  MDI_SCHOOL = 'mdi-school',
  MDI_SCRIPT = 'mdi-script',
  MDI_SHIELD_HALF_FULL = 'mdi-shield-half-full',
  MDI_SERVER = 'mdi-server',
  MDI_SHAPE = 'mdi-shape',
  MDI_SHARE = 'mdi-share',
  MDI_SHIP_WHEEL = 'mdi-ship-wheel',
  MDI_SHOE_PRINT = 'mdi-shoe-print',
  MDI_BULLSEYE = 'mdi-bullseye',
  MDI_SHORE = 'mdi-shore',
  MDI_SHUFFLE_VARIANT = 'mdi-shuffle-variant',
  MDI_SIGN_DIRECTION = 'mdi-sign-direction',
  MDI_SIGN_TEXT = 'mdi-sign-text',
  MDI_SIGNAL_VARIANT = 'mdi-signal-variant',
  MDI_SILVERWARE_FORK_KNIFE = 'mdi-silverware-fork-knife',
  MDI_SPROUT = 'mdi-sprout',
  MDI_UMBRELLA = 'mdi-umbrella',
  MDI_SQUARE_ROOT = 'mdi-square-root',
  MDI_STAIRS = 'mdi-stairs',
  MDI_STAR = 'mdi-star',
  MDI_STAR_FOUR_POINTS = 'mdi-star-four-points',
  MDI_STETHOSCOPE = 'mdi-stethoscope',
  MDI_STORE = 'mdi-store',
  MDI_SUMMIT = 'mdi-summit',
  MDI_TABLE_LARGE = 'mdi-table-large',
  MDI_TAG = 'mdi-tag',
  MDI_TARGET = 'mdi-target',
  MDI_TELESCOPE = 'mdi-telescope',
  MDI_TEST_TUBE = 'mdi-test-tube',
  MDI_THERMOMETER = 'mdi-thermometer',
  MDI_THUMB_UP = 'mdi-thumb-up',
  MDI_TICKET_CONFIRMATION = 'mdi-ticket-confirmation',
  MDI_TIMER = 'mdi-timer',
  MDI_TIMER_SAND_FULL = 'mdi-timer-sand-full',
  MDI_TOY_BRICK = 'mdi-toy-brick',
  MDI_TRAFFIC_LIGHT = 'mdi-traffic-light',
  MDI_TROPHY = 'mdi-trophy',
  MDI_TRUCK = 'mdi-truck',
}
